import React from "react"
import Login from "../styleguide-components/pages/login"

const IndexPage = () => {
  return <Login />
}

export default IndexPage
